var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "408px",
    height: "221px",
    viewBox: "0 0 408 221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-37"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-109"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-111"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-127"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-133"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-139"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-141"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-143"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-145"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-149"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-153"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-155"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-159"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-161"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-163"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633",
    id: "path-165"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.507607,102.507977 C312.057872,36.3106538 415.438521,133.470645 370.835926,229.965832 C322.877181,333.724627 240.157163,308.747664 167.711348,252.495329 C110.135736,207.788436 -36.5916247,127.989699 8.78854976,42.8503633 C76.7746405,-84.7059816 142.393256,117.94376 210.507607,102.507977 Z",
    id: "path-167"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MIA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Quiz-Node",
    transform: "translate(-664.000000, -556.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(638.079855, 449.427436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-253",
    opacity: 0.180687314,
    transform: "translate(236.920145, 217.572564) rotate(-25.000000) translate(-236.920145, -217.572564) translate(45.920145, 66.572564)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -156.914687,
    y1: 92.5809639,
    x2: 244.76519,
    y2: -277.552807,
    id: "Fill-1",
    fill: "#CECECE",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    fill: "#DDDDDD",
    mask: "url(#mask-4)",
    points: "-155.251041 94.1161706 -158.58047 91.0482195 243.099406 -279.085551 246.428836 -276.0176"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -147.154062,
    y1: 101.576265,
    x2: 254.525815,
    y2: -268.557505,
    id: "Fill-7",
    fill: "#CECECE",
    mask: "url(#mask-6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#DDDDDD",
    mask: "url(#mask-8)",
    points: "-145.48908 103.110241 -148.818509 100.04229 252.861368 -270.091481 256.190797 -267.02353"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -137.391833,
    y1: 110.570336,
    x2: 264.288044,
    y2: -259.563435,
    id: "Fill-13",
    fill: "#CECECE",
    mask: "url(#mask-10)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    fill: "#DDDDDD",
    mask: "url(#mask-12)",
    points: "-135.728454 112.105789 -139.057884 109.037838 262.621993 -261.095933 265.951422 -258.027982"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-21"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-20"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -127.629871,
    y1: 119.565637,
    x2: 274.050005,
    y2: -250.568133,
    id: "Fill-19",
    fill: "#CECECE",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-24"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-23"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#DDDDDD",
    mask: "url(#mask-16)",
    points: "-125.966493 121.099859 -129.295922 118.031908 272.383955 -252.101863 275.713384 -249.033912"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-27"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-26"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -117.869246,
    y1: 128.559954,
    x2: 283.810631,
    y2: -241.573817,
    id: "Fill-25",
    fill: "#CECECE",
    mask: "url(#mask-18)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-30"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-20",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-19"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-29"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-28",
    fill: "#DDDDDD",
    mask: "url(#mask-20)",
    points: "-116.2056 130.095161 -119.535029 127.02721 282.144847 -243.106561 285.474276 -240.03861"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-22",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-21"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-32"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -108.107285,
    y1: 137.555255,
    x2: 293.572592,
    y2: -232.578515,
    id: "Fill-31",
    fill: "#CECECE",
    mask: "url(#mask-22)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-24",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-23"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-34",
    fill: "#DDDDDD",
    mask: "url(#mask-24)",
    points: "-106.443639 139.089231 -109.773068 136.02128 291.906809 -234.112491 295.236238 -231.04454"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-39"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-26",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-25"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-38"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -98.3463919,
    y1: 146.549326,
    x2: 303.333485,
    y2: -223.584445,
    id: "Fill-37",
    fill: "#CECECE",
    mask: "url(#mask-26)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-42"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-28",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-27"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-41"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-40",
    fill: "#DDDDDD",
    mask: "url(#mask-28)",
    points: "-96.6830133 148.084779 -100.012443 145.016828 301.667434 -225.116943 304.996863 -222.048992"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-45"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-30",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-29"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-44"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -88.5844305,
    y1: 155.544627,
    x2: 313.095446,
    y2: -214.589143,
    id: "Fill-43",
    fill: "#CECECE",
    mask: "url(#mask-30)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-48"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-32",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-31"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#DDDDDD",
    mask: "url(#mask-32)",
    points: "-86.9210519 157.078849 -90.2504812 154.010898 311.429395 -216.122873 314.758825 -213.054922"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-51"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-34",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-33"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-50"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -78.8238051,
    y1: 164.538944,
    x2: 322.856072,
    y2: -205.594827,
    id: "Fill-49",
    fill: "#CECECE",
    mask: "url(#mask-34)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-54"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-36",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-35"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#DDDDDD",
    mask: "url(#mask-36)",
    points: "-77.1601593 166.074151 -80.4895885 163.0062 321.190288 -207.127571 324.519717 -204.05962"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-57"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-38",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-37"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-56"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -69.0618436,
    y1: 173.534246,
    x2: 332.618033,
    y2: -196.599525,
    id: "Fill-55",
    fill: "#CECECE",
    mask: "url(#mask-38)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-60"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-40",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-39"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-59"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-58",
    fill: "#DDDDDD",
    mask: "url(#mask-40)",
    points: "-67.3981978 175.068221 -70.7276271 172.00027 330.95225 -198.133501 334.281679 -195.06555"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-63"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-42",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-41"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-62"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -59.300951,
    y1: 182.528316,
    x2: 342.378926,
    y2: -187.605455,
    id: "Fill-61",
    fill: "#CECECE",
    mask: "url(#mask-42)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-66"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-44",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-65"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-64",
    fill: "#DDDDDD",
    mask: "url(#mask-44)",
    points: "-57.6375724 184.063769 -60.9670017 180.995818 340.712875 -189.137953 344.042304 -186.070002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-69"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-46",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-45"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-68"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -49.5389895,
    y1: 191.523617,
    x2: 352.140887,
    y2: -178.610153,
    id: "Fill-67",
    fill: "#CECECE",
    mask: "url(#mask-46)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-72"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-48",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-47"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-70",
    fill: "#DDDDDD",
    mask: "url(#mask-48)",
    points: "-47.875611 193.057839 -51.2050402 189.989888 350.474836 -180.143883 353.804266 -177.075932"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-75"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-50",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-49"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-74"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -39.7783641,
    y1: 200.517934,
    x2: 361.901512,
    y2: -169.615837,
    id: "Fill-73",
    fill: "#CECECE",
    mask: "url(#mask-50)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-78"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-52",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-77"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    fill: "#DDDDDD",
    mask: "url(#mask-52)",
    points: "-38.1147183 202.053141 -41.4441476 198.98519 360.235729 -171.148581 363.565158 -168.08063"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-81"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-54",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-53"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-80"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -30.0164027,
    y1: 209.513236,
    x2: 371.663474,
    y2: -160.620535,
    id: "Fill-79",
    fill: "#CECECE",
    mask: "url(#mask-54)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-84"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-56",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-55"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-83"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-82",
    fill: "#DDDDDD",
    mask: "url(#mask-56)",
    points: "-28.3527569 211.047211 -31.6821862 207.97926 369.99769 -162.154511 373.32712 -159.08656"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-87"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-58",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-57"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-86"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -20.2555101,
    y1: 218.508537,
    x2: 381.424367,
    y2: -151.625234,
    id: "Fill-85",
    fill: "#CECECE",
    mask: "url(#mask-58)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-90"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-60",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-59"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-89"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#DDDDDD",
    mask: "url(#mask-60)",
    points: "-18.5921315 220.042759 -21.9215608 216.974808 379.758316 -153.158963 383.087745 -150.091012"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-93"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-62",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-61"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-92"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -10.4935486,
    y1: 227.502854,
    x2: 391.186328,
    y2: -142.630917,
    id: "Fill-91",
    fill: "#CECECE",
    mask: "url(#mask-62)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-96"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-64",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-63"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-95"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#DDDDDD",
    mask: "url(#mask-64)",
    points: "-8.83017004 229.036829 -12.1595993 225.968878 389.520277 -144.164893 392.849707 -141.096942"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-99"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-66",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-65"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-98"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -0.732923223,
    y1: 236.498155,
    x2: 400.946953,
    y2: -133.635616,
    id: "Fill-97",
    fill: "#CECECE",
    mask: "url(#mask-66)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-102"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-67"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-101"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#DDDDDD",
    mask: "url(#mask-68)",
    points: "0.930722576 238.032131 -2.3987067 234.96418 399.28117 -135.169591 402.610599 -132.10164"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-105"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-70",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-69"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-104"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.02903823,
    y1: 245.492226,
    x2: 410.708915,
    y2: -124.641545,
    id: "Fill-103",
    fill: "#CECECE",
    mask: "url(#mask-70)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-108"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-72",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-107"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-106",
    fill: "#DDDDDD",
    mask: "url(#mask-72)",
    points: "10.692684 247.026447 7.36325475 243.958496 409.043131 -126.175274 412.372561 -123.107323"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-111"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-74",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-73"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-110"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.7899308,
    y1: 254.487527,
    x2: 420.469807,
    y2: -115.646244,
    id: "Fill-109",
    fill: "#CECECE",
    mask: "url(#mask-74)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-114"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-76",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-75"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-112",
    fill: "#DDDDDD",
    mask: "url(#mask-76)",
    points: "20.4533094 256.021749 17.1238802 252.953798 418.803757 -117.179973 422.133186 -114.112022"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-117"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-78",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-77"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-116"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.5518923,
    y1: 263.481844,
    x2: 430.231769,
    y2: -106.651927,
    id: "Fill-115",
    fill: "#CECECE",
    mask: "url(#mask-78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-120"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-80",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-79"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-119"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-118",
    fill: "#DDDDDD",
    mask: "url(#mask-80)",
    points: "30.2155381 265.015819 26.8861088 261.947868 428.565985 -108.185903 431.895415 -105.117951"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-123"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-82",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-81"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-122"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.3125177,
    y1: 272.477145,
    x2: 439.992394,
    y2: -97.6566255,
    id: "Fill-121",
    fill: "#CECECE",
    mask: "url(#mask-82)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-126"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-84",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-125"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-124",
    fill: "#DDDDDD",
    mask: "url(#mask-84)",
    points: "39.9761635 274.011121 36.6467342 270.94317 438.326611 -99.1906011 441.65604 -96.12265"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-129"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-86",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-85"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-128"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.0744791,
    y1: 281.471216,
    x2: 449.754356,
    y2: -88.6625551,
    id: "Fill-127",
    fill: "#CECECE",
    mask: "url(#mask-86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-132"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-88",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-87"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-131"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-130",
    fill: "#DDDDDD",
    mask: "url(#mask-88)",
    points: "49.7381249 283.005437 46.4086957 279.937486 448.088572 -90.1962844 451.418002 -87.1283334"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-135"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-90",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-89"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-134"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57.8353718,
    y1: 290.466517,
    x2: 459.515248,
    y2: -79.6672536,
    id: "Fill-133",
    fill: "#CECECE",
    mask: "url(#mask-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-138"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-92",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-91"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-137"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-136",
    fill: "#DDDDDD",
    mask: "url(#mask-92)",
    points: "59.4987504 292.000739 56.1693211 288.932788 457.849198 -81.2009829 461.178627 -78.1330319"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-141"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-94",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-93"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-140"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67.5973332,
    y1: 299.460834,
    x2: 469.27721,
    y2: -70.672937,
    id: "Fill-139",
    fill: "#CECECE",
    mask: "url(#mask-94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-144"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-96",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-95"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-143"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-142",
    fill: "#DDDDDD",
    mask: "url(#mask-96)",
    points: "69.260979 300.994809 65.9315497 297.926858 467.611426 -72.2069125 470.940856 -69.1389615"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-147"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-98",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-97"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-146"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77.3579586,
    y1: 308.456135,
    x2: 479.037835,
    y2: -61.6776355,
    id: "Fill-145",
    fill: "#CECECE",
    mask: "url(#mask-98)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-150"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-100",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-149"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-148",
    fill: "#DDDDDD",
    mask: "url(#mask-100)",
    points: "79.0216044 309.990111 75.6921751 306.92216 477.372052 -63.211611 480.701481 -60.1436599"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-153"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-102",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-101"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-152"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87.1201873,
    y1: 317.450206,
    x2: 488.800064,
    y2: -52.6835651,
    id: "Fill-151",
    fill: "#CECECE",
    mask: "url(#mask-102)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-156"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-104",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-103"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-155"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-154",
    fill: "#DDDDDD",
    mask: "url(#mask-104)",
    points: "88.7835659 318.984427 85.4541366 315.916476 487.134013 -54.2172944 490.463442 -51.1493433"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-159"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-106",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-105"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-158"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.8808127,
    y1: 326.445507,
    x2: 498.560689,
    y2: -43.6882636,
    id: "Fill-157",
    fill: "#CECECE",
    mask: "url(#mask-106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-162"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-108",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-107"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-160",
    fill: "#DDDDDD",
    mask: "url(#mask-108)",
    points: "98.5441913 327.979729 95.214762 324.911778 496.894639 -45.2219929 500.224068 -42.1540418"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-165"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-110",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-109"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-164"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106.642774,
    y1: 335.439824,
    x2: 508.322651,
    y2: -34.693947,
    id: "Fill-163",
    fill: "#CECECE",
    mask: "url(#mask-110)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-168"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-112",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-111"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-166",
    fill: "#DDDDDD",
    mask: "url(#mask-112)",
    points: "108.30642 336.973799 104.976991 333.905848 506.656867 -36.2279225 509.986297 -33.1599714"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-171"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-114",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-113"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-170"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.4034,
    y1: 344.435125,
    x2: 518.083276,
    y2: -25.6986455,
    id: "Fill-169",
    fill: "#CECECE",
    mask: "url(#mask-114)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-174"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-116",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-115"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-173"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-172",
    fill: "#DDDDDD",
    mask: "url(#mask-116)",
    points: "118.067045 345.969101 114.737616 342.90115 516.417493 -27.232621 519.746922 -24.1646699"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-177"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-118",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-117"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-176"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126.165628,
    y1: 353.429196,
    x2: 527.845505,
    y2: -16.7045751,
    id: "Fill-175",
    fill: "#CECECE",
    mask: "url(#mask-118)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-180"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-120",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-119"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-179"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-178",
    fill: "#DDDDDD",
    mask: "url(#mask-120)",
    points: "127.829007 354.963417 124.499578 351.895466 526.179454 -18.2383044 529.508883 -15.1703533"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-183"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-122",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-121"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-182"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135.926254,
    y1: 362.424497,
    x2: 537.60613,
    y2: -7.70927354,
    id: "Fill-181",
    fill: "#CECECE",
    mask: "url(#mask-122)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-186"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-124",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-123"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-185"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-184",
    fill: "#DDDDDD",
    mask: "url(#mask-124)",
    points: "137.589632 363.958719 134.260203 360.890768 535.94008 -9.24300286 539.269509 -6.17505178"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-189"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-126",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-125"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-188"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.688215,
    y1: 371.418814,
    x2: 547.368092,
    y2: 1.28504307,
    id: "Fill-187",
    fill: "#CECECE",
    mask: "url(#mask-126)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-192"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-128",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-127"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-191"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-190",
    fill: "#DDDDDD",
    mask: "url(#mask-128)",
    points: "147.351861 372.95402 144.022432 369.883607 545.702308 -0.247701347 549.031737 2.82024973"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-195"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-130",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-129"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-194"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155.44884,
    y1: 380.414115,
    x2: 557.128717,
    y2: 10.2803446,
    id: "Fill-193",
    fill: "#CECECE",
    mask: "url(#mask-130)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-198"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-132",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-131"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-197"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-196",
    fill: "#DDDDDD",
    mask: "url(#mask-132)",
    points: "157.113822 381.948091 153.781721 378.88014 555.46427 8.74636905 558.793699 11.8143201"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-201"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-134",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-133"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-200"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165.211069,
    y1: 389.408186,
    x2: 566.890946,
    y2: 19.274415,
    id: "Fill-199",
    fill: "#CECECE",
    mask: "url(#mask-134)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-204"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-136",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-203"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-202",
    fill: "#DDDDDD",
    mask: "url(#mask-136)",
    points: "166.874448 390.943639 163.545018 387.875688 565.224895 17.7419168 568.554324 20.8098679"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-207"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-138",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-137"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-206"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.971695,
    y1: 398.403487,
    x2: 576.651571,
    y2: 28.2697165,
    id: "Fill-205",
    fill: "#CECECE",
    mask: "url(#mask-138)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-210"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-140",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-139"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-208",
    fill: "#DDDDDD",
    mask: "url(#mask-140)",
    points: "176.636409 399.937709 173.30698 396.869758 574.986857 26.7359872 578.316286 29.8039383"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-213"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-142",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-141"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-212"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 184.733656,
    y1: 407.397804,
    x2: 586.413533,
    y2: 37.2640331,
    id: "Fill-211",
    fill: "#CECECE",
    mask: "url(#mask-142)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-216"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-144",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-143"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-215"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-214",
    fill: "#DDDDDD",
    mask: "url(#mask-144)",
    points: "186.397302 408.933011 183.067873 405.865059 584.747749 35.7312887 588.077178 38.7992398"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-219"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-146",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-145"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-218"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 194.494281,
    y1: 416.393105,
    x2: 596.174158,
    y2: 46.2593346,
    id: "Fill-217",
    fill: "#CECECE",
    mask: "url(#mask-146)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-222"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-148",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-147"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-221"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-220",
    fill: "#DDDDDD",
    mask: "url(#mask-148)",
    points: "196.159263 417.927081 192.829834 414.85913 594.509711 44.7253591 597.83914 47.7933102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-225"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-149"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-224"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.25651,
    y1: 425.387176,
    x2: 605.936387,
    y2: 55.253405,
    id: "Fill-223",
    fill: "#CECECE",
    mask: "url(#mask-150)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-228"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-152",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-227"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-226",
    fill: "#DDDDDD",
    mask: "url(#mask-152)",
    points: "205.919889 426.922629 202.590459 423.854678 604.270336 53.7209068 607.599765 56.7888579"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-231"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-154",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-153"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-230"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.018471,
    y1: 434.382477,
    x2: 615.698348,
    y2: 64.2487065,
    id: "Fill-229",
    fill: "#CECECE",
    mask: "url(#mask-154)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-234"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-156",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-155"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-233"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-232",
    fill: "#DDDDDD",
    mask: "url(#mask-156)",
    points: "215.68185 435.916699 212.352421 432.848748 614.032297 62.7149772 617.361727 65.7829283"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-237"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-158",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-157"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-236"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.779097,
    y1: 443.376794,
    x2: 625.458974,
    y2: 73.2430231,
    id: "Fill-235",
    fill: "#CECECE",
    mask: "url(#mask-158)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-240"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-160",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-159"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-239"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-238",
    fill: "#DDDDDD",
    mask: "url(#mask-160)",
    points: "225.442743 444.912001 222.113313 441.844049 623.79319 71.7102787 627.122619 74.7782298"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-243"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-162",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-161"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-242"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 233.541058,
    y1: 452.372095,
    x2: 635.220935,
    y2: 82.2383247,
    id: "Fill-241",
    fill: "#CECECE",
    mask: "url(#mask-162)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-246"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-164",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-163"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-245"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-244",
    fill: "#DDDDDD",
    mask: "url(#mask-164)",
    points: "235.204704 453.906071 231.875275 450.83812 633.555151 80.7043491 636.884581 83.7723002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-249"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-166",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-165"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-248"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 243.301951,
    y1: 461.367397,
    x2: 644.981828,
    y2: 91.2336262,
    id: "Fill-247",
    fill: "#CECECE",
    mask: "url(#mask-166)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-252"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-168",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-167"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-251"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-250",
    fill: "#DDDDDD",
    mask: "url(#mask-168)",
    points: "244.96533 462.901619 241.6359 459.833668 643.315777 89.6998969 646.645206 92.7678479"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "3167509_sync_complete_icon",
    transform: "translate(161.920145, 147.572564)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.337932,68 C138.959131,95.8883212 122.724886,122.55969 96.2346382,132.24311 C69.7443906,141.926529 40.0567139,132.041763 24.7261715,108.433753 L9,111.621856 C25.5050642,141.902683 60.5232374,157.160255 94.0345972,148.671803 C127.545957,140.18335 151.00493,110.113475 151,75.6531515 C151,73.0973797 150.865743,70.5727988 150.615221,68.081443 L135.337932,68 Z",
    id: "Path",
    fill: "#097AD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6620678,83 C12.0411545,55.1116733 28.2754046,28.4404416 54.7654989,18.7570158 C81.2555933,9.07359003 110.943119,18.9581655 126.273828,42.5659886 L142,39.3783225 C125.494929,9.09734554 90.4767354,-6.1602937 56.9653662,2.32821718 C23.453997,10.8167281 -0.00496451919,40.8867722 0,75.3472658 C0,77.9030492 0.134257444,80.4280936 0.384779154,82.9190087 L15.6620678,83 Z",
    id: "Path",
    fill: "#097AD0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4C9AE8",
    points: "106 53 151 8 151 53"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#4C9AE8",
    points: "45 98 0 143 0 98"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#09D00B",
    points: "109 66.5952017 98.2942151 56 70.2577783 83.7347188 55.7057849 69.3432152 45 79.9384169 70.2577783 105"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetake);
export default __webpack_public_path__ + "static/media/retake.c395d8a8a11837ae735f9032656ebb45.svg";
export { ForwardRef as ReactComponent };